import { IconFn, IconSvg } from "../createIcon";

export const EyeIcon: IconFn = ({ color = "#655C94", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 18, height: 14 }} {...props}>
    <path
      d="M9 11.05a4.05 4.05 0 1 1 0-8.101 4.05 4.05 0 0 1 0 8.1ZM9 .7C2.7.7 0 7 0 7s2.7 6.3 9 6.3S18 7 18 7 15.3.7 9 .7Z"
      fill={color}
    />
    <path d="M9 9.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" fill={color} />
  </IconSvg>
);
